"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _index = require("../../../index");

var _index2 = require("../../../utils/index");

var _reactJss = _interopRequireDefault(require("react-jss"));

var _toaster_styles = _interopRequireDefault(require("./toaster_styles"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
} // Blob that needs to be passes through displayMessage call:
// id is automatically generated in messageStatus reducer
// {
//     type: 'toaster', //toaster, notification
//     close: true, //bool to render x button or not
//     variant: 'primary', //i.e primary, secondary - determines color
//     time: 3000, //integer in milliseconds to represent how long before component is killed
//     align: 'top-left', //top-left, top-right, bottom-left, bottom-right position to be rendered
//     message: <p>Hey</p>, //message in jsx format to be rendered
//     handleClick: null //callback
// }

/* ========== ~~~~~~~~~~ TOASTER ~~~~~~~~~~ ========== */


var Toaster =
/*#__PURE__*/
function (_Component) {
  _inherits(Toaster, _Component);

  function Toaster(props) {
    var _this;

    _classCallCheck(this, Toaster);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Toaster).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "renderCloseButton", function () {
      return _this.props.close ? _react.default.createElement("span", {
        className: 'close',
        onClick: _this.handleClose
      }, " ", _react.default.createElement(_index.Icon, {
        name: "times"
      })) : null;
    });

    _defineProperty(_assertThisInitialized(_this), "handleClose", function () {
      _this.props.removeMessage('id', _this.props.id, _this.props.type, _this.props.align);

      if (_this.props.handleClose !== null) {
        _this.props.handleClose();
      }
    });

    _this.timeout = null;
    return _this;
  }

  _createClass(Toaster, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      if (!!this.props.time) {
        this.timeout = setTimeout(function () {
          _this2.props.removeMessage('id', _this2.props.id, _this2.props.type, _this2.props.align);

          clearTimeout(_this2.timeout);
        }, this.props.time);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.timeout);
    }
  }, {
    key: "render",
    value: function render() {
      if (this.props.enabled === false) return null;

      if ((0, _index2.hasLocalStorage)(this.props.name)) {
        this.props.removeMessage('name', this.props.name, this.props.type, this.props.align);
        return null;
      }

      return _react.default.createElement("div", {
        className: "message toaster ".concat((0, _index2.generateClasses)(this.props), " ").concat(this.props.classes.toaster, " hasCloseButton-").concat(this.props.close)
      }, _react.default.createElement("div", {
        className: 'details'
      }, this.props.icon ? _react.default.createElement(_index.Icon, {
        name: "".concat(this.props.icon, " message-icon")
      }) : null, _react.default.createElement("p", {
        className: "text"
      }, this.props.title && _react.default.createElement("strong", {
        className: "title"
      }, this.props.title, ":"), this.props.message)), this.renderCloseButton());
    }
  }]);

  return Toaster;
}(_react.Component);
/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */


var _default = (0, _reactJss.default)(_toaster_styles.default)(Toaster);

exports.default = _default;